import { useEffect } from "react";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import SubmitInitialApplicationComponent from "../../components/applicationComponents/submitInitialApplication/SubmitInitialApplicationComponent";

export default function SubmitInitialApplicationPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Submit KIS Application for Assessment",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);
  return (
    <>
      <SubmitInitialApplicationComponent disabled={false} />
    </>
  );
}
